import { booleanAttribute, ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { StateTagType } from '@shared/ui-components/state-tag/models/tag.model';

@Component({
  selector: 'ac-state-tag',
  standalone: true,
  template: '<ng-content/>',
  styleUrls: ['./state-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class StateTagComponent {
  /** HOST CLASSES */
  @HostBinding('class')
  @Input({ required: true })
  public type!: StateTagType;

  // Optional attributes
  @Input({ transform: booleanAttribute }) small?: boolean | string;
}
